module.exports = {
  "version": "0.26.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 10
// module chunks = 0